import {
  enumBranchPref,
  kAspectRatioLookup,
  kDefaultAspectRatio,
  kSpacingAdjElementType
} from "../constants";
import { QSARightClick } from "./QSARightClick";
import { QXMLObject } from "./QXMLObject";
import { StringToBool } from "../utils/StringToBool.js";

export class QOptimizePref extends QXMLObject {
  constructor() {
    super();
    this.fAspectRatio = null;
    this.fAllowSort = true;
    this.fBranchPref = enumBranchPref.tree;
    this.fTreeSingles = true;
    this.fParam = "";
  }

  // AUTOBUILD
  InitConfig() {
    this.fAllowSort = true;
    this.fBranchPref = enumBranchPref.tree;
    this.fTreeSingles = true;
    this.fParam = "";
    this.fAspectRatio = kDefaultAspectRatio; //X = 7;
    //this.fAspectY = 5;

    this.SetXMLElementName("qoptimizeprefs");
  }

  GetAspectRatio() {
    return this.fAspectRatio;
  }

  SetAspectRatio(aspectRatio) {
    this.fAspectRatio = aspectRatio;
  }

  //kAspectRatioLookup
  SetRealAspectRatio(realAspectRaio) {
    //This function exists because for some reason we defined a set list of aspect ratios.
    this.fAspectRatio = 9;
    for (var anAspectRatioIdx in kAspectRatioLookup) {
      if (realAspectRaio <= kAspectRatioLookup[anAspectRatioIdx]) {
        this.fAspectRatio = parseInt(anAspectRatioIdx);
        return;
      }
    }
  }

  GetAllowSort() {
    return this.fAllowSort;
  }

  SetAllowSort(allowSort) {
    this.fAllowSort = allowSort;
  }

  GetBranchPref() {
    return this.fBranchPref;
  }

  SetBranchPref(branchPref) {
    this.fBranchPref = branchPref;
  }

  SetParam(param) {
    this.fParam = param;
  }

  GetParam() {
    return this.fParam;
  }

  GetTreeSingles() {
    return this.fTreeSingles;
  }

  SetTreeSingles(treeSingles) {
    this.fTreeSingles = treeSingles;
  }

  DoHandleRightClick(hitElement, x, y) {
    if (hitElement == null) return;

    var eType = hitElement.GetElementType();
    if (eType == kSpacingAdjElementType) {
      this.fRightClickCtrl = hitElement["parentctrl"];
      var w = this.fWSMgr;
      var s = new QSARightClick();
      s.InitMenu("SARightClick", w, x, y);
      w.PushPanel(s);
    }
  }

  Clone() {
    var c = new QOptimizePref();
    c.InitConfig();

    c.fAspectRatio = this.fAspectRatio;
    //	c.fAspectY = this.fAspectY;

    c.fAllowSort = this.fAllowSort;
    c.fBranchPref = this.fBranchPref;
    c.fTreeSingles = this.fTreeSingles;
    c.fParam = this.fParam;

    return c;
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("optr", this.fAspectRatio, stream);
    this.OutputElementTriple("optp", this.fAllowSort, this.fBranchPref, this.fTreeSingles, stream); // this.fWallChart, stream);
  }

  OutputToJSON(json) {
    json["optimizePrefs"] = {};
    var optPrefs = json["optimizePrefs"];
    optPrefs["aspectRatio"] = this.fAspectRatio;
    optPrefs["allowSort"] = this.fAllowSort;
    optPrefs["branchPref"] = this.fBranchPref;
    optPrefs["treeSingles"] = this.fTreeSingles;
  }

  LoadSubElements(objTree) {
    this.InitConfig();
    var valueList = objTree.GetValueListForChild("optr", false);
    if (valueList != null) {
      this.fAspectRatio = parseInt(valueList[0]);
      //	this.fAspectY = parseInt(valueList[1]);
    }

    var valueList = objTree.GetValueListForChild("optp", false);
    if (valueList != null) {
      this.fAllowSort = StringToBool(valueList[0]);
      this.fBranchPref = parseInt(valueList[1]);
      this.fTreeSingles = StringToBool(valueList[2]);
    }
  }

  LoadFromJSON(json) {
    this.fAspectRatio = json["aspectRatio"];
    this.fAllowSort = json["allowSort"];
    this.fBranchPref = json["branchPref"];
    this.fTreeSingles = json["treeSingles"];
  }
}
